import type {YoutubeVideo} from "@/models/youtube_video";
import type {PaginatedResponse} from "@/responses/general";
import axiosInstance from "@/utils/axiosInstance";
import Utils from "@/helpers/utils";

class YoutubeVideoService {
  async list(channelID: string, filters: any): Promise<PaginatedResponse<YoutubeVideo[]>> {
    const query = Utils.buildSearchQueryString(filters);
    const {data} = await axiosInstance.get(`/apps/youtube/channels/${channelID}/videos${query}`);
    return data;
  }

  async get(videoID: string): Promise<YoutubeVideo> {
    const {data} = await axiosInstance.get(`/apps/youtube/videos/${videoID}`);
    return data;
  }
}

export default new YoutubeVideoService();
